module.exports = __webpack_public_path__ + "static/img/bonus_2.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_2.png
// module id = mdR+
// module chunks = 0